import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'
import routerArr from './routers'

//创建路由
const router = createRouter({
	// history: createWebHashHistory(),
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [...routerArr],
	scrollBehavior(to: any) {
		// mall 路由使用 .mall-layout 作为滚动容器
		if (to.path.startsWith('/mall')) {
			return { top: 0, el: '.mall-layout' }
		}
		// admin 路由使用 .cc_layout_right 作为滚动容器
		return { top: 0, el: '.cc_layout_right' }
	}
})

// 路由拦截
router.beforeEach((to: any, _from: any, next: any) => {
	// 白名单路由，无需认证
	const whiteList = ['/login', '/404', '/403']
	if (whiteList.includes(to.path)) {
		next()
		return
	}
	// mall 路由无需强制登录（由 axios 拦截器处理 401）
	next()
})

export default router
